import { useContext } from 'react';
import { DataContext } from '../data/DataContext';
import { DropDown, Input } from '../components';
import { lstTypeDocument, catCivilStatus } from '../data/MochaData'

const Step6 = () => {
    const { AutoCR, setAutoCR, changeHandler } = useContext(DataContext);
    const onChange = (property: string, value: string) => setAutoCR({ ...AutoCR, [property]: value });

    return (
        <>
            <DropDown
                label='Tipo de identificación'
                field='typeDocumentInsured'
                valueSelect={AutoCR.typeDocumentInsured}
                dataProvider={lstTypeDocument}
                onChangeSelect={onChange}

            />

            {AutoCR.typeDocumentInsured === '1' &&
                <Input
                    id='identificationInsured'
                    label='Número de identificación'
                    value={AutoCR.identificationInsured}
                    field='identificationInsured'
                    onChange={changeHandler}
                    placeholder="Identificación"
                    type='mask'
                    mask="9-9999-9999"
                    pattern="\d-\d\d\d\d-\d\d\d\d"
                    title="Documento invalido"
                />
            }

            {AutoCR.typeDocumentInsured !== '1' &&
                < Input
                    id='identificationInsured'
                    label='Número de identificación'
                    value={AutoCR.identificationInsured}
                    field='identificationInsured'
                    onChange={changeHandler}
                />
            }

            <Input
                label='Nombres'
                value={AutoCR.firstName}
                onChange={changeHandler}
                field='firstName'
                id='firstName'
                placeholder='Ejem: Mario Antonio'
            />
            <Input
                label='Apellidos'
                value={AutoCR.lastName}
                onChange={changeHandler}
                field='lastName'
                id='lastName'
                placeholder='Ejem: Quiroz Rodríguez'
            />
            <Input
                label='Número de Celular'
                value={AutoCR.phone}
                onChange={changeHandler}
                field='phone'
                id='phone'
                placeholder='0000-0000'
                type='mask'
                mask="9999-9999"
                title="Documento invalido"
            />
            <Input
                label='Correo electrónico'
                value={AutoCR.mail}
                onChange={changeHandler}
                field='mail'
                id='mail'
                placeholder='usuario@dominio.com'
            />
            {/* <DropDown 
                dataProvider={catGender}
                field='sex'
                label='Sexo'
                valueSelect={AutoCR.sex}
                onChangeSelect={onChange}
                placeholder='Selecciona'
            />*/}
            <DropDown 
                dataProvider={catCivilStatus}
                field='civilStatus'
                label='Estado civil'
                valueSelect={AutoCR.civilStatus}
                onChangeSelect={onChange}
                placeholder='Selecciona'
            /> 
        </>
    )
}

export { Step6 }
